<template>
  <div class="home-rail-wrap">
    <button
      v-if="showControls"
      type="button"
      class="home-rail-control home-rail-control--prev"
      :aria-label="`Voltar ${label}`"
      @click="scrollBy(-1)"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </button>
    <div ref="rail" class="home-scroll-rail" :class="railClass">
      <slot />
    </div>
    <button
      v-if="showControls"
      type="button"
      class="home-rail-control home-rail-control--next"
      :aria-label="`Avancar ${label}`"
      @click="scrollBy(1)"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "HomeBaseRail",
  props: {
    label: { type: String, default: "trilho" },
    variant: { type: String, default: "projects" },
    showControls: { type: Boolean, default: true },
  },
  computed: {
    railClass() {
      return `home-scroll-rail--${this.variant}`;
    },
  },
  methods: {
    scrollBy(direction) {
      const rail = this.$refs.rail;
      if (!rail) return;
      const amount = Math.max(rail.clientWidth * 0.82, 280);
      rail.scrollBy({ left: direction * amount, behavior: "smooth" });
    },
  },
};
</script>
